<!--
This component generates the requests list group for the specified {{status}.
Receiver must pass an array to {requests} to let the component generate the proper ui.
-->
<template>
  <section class="invite-section">
    <div class="list-group-container">
      <div class="d-flex flex-row list-row-header">
        <div class="p-2 w-50">Name</div>
        <!-- <div class="p-2 w-25">Individual Name</div> -->
        <div class="p-2 w-25">Request Status</div>
        <!-- <div class="p-2 w-25" v-if="passStatus !== 'Inactive'">
          Action
        </div> -->
      </div>

      <!--Appears if there's no request-->
      <div class="d-flex flex-row list-row-empty" v-if="!hasRequests">
        <div class="flex-fill">No request/s yet.</div>
      </div>
      <!--end no invite-->
      <!-- appears if with request/s -->
      <div class="list-rows" v-else>
        <div v-for="(data, index) in requests" :key="index" class="d-flex flex-row list-row">
          <div class="px-2 w-50 list-column-item"> {{ data.individual_details.full_name }}</div>
          <div class="px-2 w-25 list-column-item">
            {{ data.request_status }}
          </div>
          <div class="px-2 w-25 list-column-action"
            v-if="data.request_status !=='Accepted' && data.request_status !=='Rejected'">
            <button class="simple-link" @click="showModalRequest(data, $event)">
              <i class="fas fa-info"></i>
            </button>
          </div>
          <div class="px-2 w-25 list-column-action" v-else></div>
        </div>
      </div>
      <!-- end with requests -->
    </div>
    <!--end list group-->
  </section>
</template>

<script>
import '@/assets/styles/list-style.css'

export default {
  name: 'request-list-view',
  data() {
    return {
      isToDelete: this.accountType === 'business'
    }
  },
  props: {
    // passStatus: String,
    accountType: String,
    requests: Array,
    hasRequests: Boolean,
    showModalRequest: Function
    // rejectRequest: Function,
    // acceptRequest: Function
  },
  computed: {
    statusObject: function () {
      return {
        'status-active': this.status === "Active",
        'status-inactive': this.status === "Inactive",
        'status-pending': this.status === "Pending"
      }
    }
  }
}
</script>

<style scoped>
.invite-section {
  margin-top: 48px;
}
.invite-status-header {
  display:flex;
  align-items: center;
}
.invite-status-title {
  font-family: "HKGrotesk-Bold", Helvetica, sans-serif;
  color: #00386A;
  font-size: 20px;
}
.invite-status-indicator {
  width: 12px;
  height: 12px;

  border-radius: 100%;
  margin-right: 12px;
}

/* Status indicator color styles */
.status-active {
  background-color: #42BB79;
}
.status-inactive {
  background-color: #547181;
}
.status-pending {
  background-color: #EDC834;
}
</style>



// WEBPACK FOOTER //
// src/components/listview/RequestsListView.vue